import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { settings } = useSettings();
  const { t, getBilingualValue } = useLanguage();

  return (
    <footer className="bg-gray-900 text-gray-400 py-16">
      <div className="container mx-auto px-6">
        <div className="text-center space-y-6">
          <div>
            <div className="text-2xl font-bold text-white mb-2">ASEAN Business Forum</div>
            <p className="text-sm">{getBilingualValue(settings.footer?.text, 'footer.tagline')}</p>
          </div>
          <div className="flex justify-center space-x-6">
            <a href={settings.footer?.facebook || '#'} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-white transition-colors">
              <Facebook size={20} />
            </a>
            <a href={settings.footer?.twitter || '#'} target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="hover:text-white transition-colors">
              <Twitter size={20} />
            </a>
            <a href={settings.footer?.linkedin || '#'} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:text-white transition-colors">
              <Linkedin size={20} />
            </a>
            <a href={settings.footer?.instagram || '#'} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white transition-colors">
              <Instagram size={20} />
            </a>
          </div>
          <div className="text-sm">
            <a href="#" className="hover:text-white transition-colors">{t('footer.privacyPolicy')}</a>
            {' · '}
            <a href="#" className="hover:text-white transition-colors">{t('footer.termsOfService')}</a>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-sm">
          {getBilingualValue(settings.footer?.copyright, 'footer.copyright')}
        </div>
      </div>
    </footer>
  );
};
